module.exports = __webpack_public_path__ + "static/media/no-image.5a021ab9.png";